var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.page == "default"
    ? _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c(
            "w-card-title",
            [
              _vm._v(" " + _vm._s(_vm.title) + " "),
              _c("w-spacer"),
              _c(
                "w-link",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("common.close"),
                      expression: "$ct('common.close')",
                    },
                  ],
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-list" } },
            _vm._l(_vm.types, function (t) {
              return _c(
                "w-list-item",
                {
                  key: t.value,
                  on: {
                    click: function ($event) {
                      return _vm.selectItemType(t.value)
                    },
                  },
                },
                [_c("w-list-item-text", [_vm._v(_vm._s(t.text))])],
                1
              )
            }),
            1
          ),
        ],
        1
      )
    : _vm.page == "custom"
    ? _c("app-custom-settings", {
        attrs: { title: _vm.title, item: _vm.item },
        on: {
          close: function ($event) {
            return _vm.close()
          },
          confirm: function ($event) {
            return _vm.onItem()
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }